import type {ParserT} from '@freckle/parser'
import {string, map} from '@freckle/parser'
import type {SupportedLanguage} from '../supported-language'
import {SupportedLanguages} from '../supported-language'

export type LangT = SupportedLanguage

export const Languages = {
  parseT(): ParserT<LangT> {
    return map(string(), 'LangT', SupportedLanguages.unsafeParse)
  },

  format: SupportedLanguages.mkMatch<string>({
    onEn: () => 'English',
    onEs: () => 'Spanish',
    onEnGB: () => 'British English'
  }),

  ...SupportedLanguages
}
